import React, { useState, Component } from 'react';
import { Smartphone, Glasses, Compass, Zap, Settings, Crown, ChevronRight } from 'lucide-react';
import { VRDeviceSetup } from './VRARComponents/VRDeviceSetup';
import { VREnvironments } from './VRARComponents/VREnvironments';
import { ARCompanionMode } from './VRARComponents/ARCompanionMode';
import { VRTutorials } from './VRARComponents/VRTutorials';
import { VRSubscription } from './VRARComponents/VRSubscription';
export const VRARSection = () => {
  const [activeTab, setActiveTab] = useState('environments');
  const renderContent = () => {
    switch (activeTab) {
      case 'setup':
        return <VRDeviceSetup data-id="element-22955" />;
      case 'environments':
        return <VREnvironments data-id="element-22956" />;
      case 'ar':
        return <ARCompanionMode data-id="element-22957" />;
      case 'tutorials':
        return <VRTutorials data-id="element-22958" />;
      case 'subscription':
        return <VRSubscription data-id="element-22959" />;
      default:
        return <VREnvironments data-id="element-22960" />;
    }
  };
  return <section className="space-y-6" data-id="element-22961">
      <div className="flex items-center justify-between" data-id="element-22962">
        <div className="flex items-center gap-2" data-id="element-22963">
          <h2 className="text-lg font-bold" data-id="element-22964">VR & AR Experience</h2>
          <div className="text-xs px-2 py-0.5 bg-pink-500/20 rounded-full text-pink-400" data-id="element-22965">
            New
          </div>
        </div>
        <button className="text-sm text-pink-400" data-id="element-22966">Help</button>
      </div>
      <div className="bg-gray-900 rounded-xl border border-gray-800 overflow-hidden" data-id="element-22967">
        <div className="overflow-x-auto" data-id="element-22968">
          <div className="flex p-2 gap-2" data-id="element-22969">
            <button className={`px-3 py-1.5 rounded-lg text-sm flex items-center gap-1 whitespace-nowrap ${activeTab === 'setup' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-800 text-gray-300'}`} onClick={() => setActiveTab('setup')} data-id="element-22970">
              <Smartphone size={14} data-id="element-22971" />
              <span data-id="element-22972">Device Setup</span>
            </button>
            <button className={`px-3 py-1.5 rounded-lg text-sm flex items-center gap-1 whitespace-nowrap ${activeTab === 'environments' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-800 text-gray-300'}`} onClick={() => setActiveTab('environments')} data-id="element-22973">
              <Compass size={14} data-id="element-22974" />
              <span data-id="element-22975">Environments</span>
            </button>
            <button className={`px-3 py-1.5 rounded-lg text-sm flex items-center gap-1 whitespace-nowrap ${activeTab === 'ar' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-800 text-gray-300'}`} onClick={() => setActiveTab('ar')} data-id="element-22976">
              <Zap size={14} data-id="element-22977" />
              <span data-id="element-22978">AR Mode</span>
            </button>
            <button className={`px-3 py-1.5 rounded-lg text-sm flex items-center gap-1 whitespace-nowrap ${activeTab === 'tutorials' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-800 text-gray-300'}`} onClick={() => setActiveTab('tutorials')} data-id="element-22979">
              <Settings size={14} data-id="element-22980" />
              <span data-id="element-22981">Tutorials</span>
            </button>
            <button className={`px-3 py-1.5 rounded-lg text-sm flex items-center gap-1 whitespace-nowrap ${activeTab === 'subscription' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-800 text-gray-300'}`} onClick={() => setActiveTab('subscription')} data-id="element-22982">
              <Crown size={14} data-id="element-22983" />
              <span data-id="element-22984">VR Premium</span>
            </button>
          </div>
        </div>
        <div className="p-4 border-t border-gray-800" data-id="element-22985">{renderContent()}</div>
      </div>
      <div className="bg-gradient-to-r from-pink-900/30 to-purple-900/30 rounded-xl border border-pink-800/50 p-4" data-id="element-22986">
        <div className="flex items-center gap-3" data-id="element-22987">
          <div className="w-10 h-10 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-22988">
            <Glasses size={18} data-id="element-22989" />
          </div>
          <div data-id="element-22990">
            <h3 className="font-medium" data-id="element-22991">Experience SinShift in VR</h3>
            <p className="text-sm text-gray-300" data-id="element-22992">
              Take your relationship to the next level with immersive
              experiences
            </p>
          </div>
        </div>
        <div className="mt-3 flex items-center justify-between" data-id="element-22993">
          <div className="flex items-center gap-1" data-id="element-22994">
            <span className="text-purple-400" data-id="element-22995">💎</span>
            <span className="text-sm" data-id="element-22996">15 tokens to unlock</span>
          </div>
          <button className="px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium" data-id="element-22997">
            Try Now
          </button>
        </div>
      </div>
    </section>;
};